export default "__VITE_ASSET__Q76fbzlH__"